import { API_JWT_BASE_URL } from '../http'
import { API_V2_BASE_URL } from '../http'

export const SEARCH_JOBS_API = `${API_JWT_BASE_URL}/Jobs/search`
export const BASE_JOB_API = `${API_JWT_BASE_URL}/Jobs/`
export const BASE_JOB_V2_API = `${API_V2_BASE_URL}/Jobs/`
export const REPORT_JOBS_API = `${API_JWT_BASE_URL}/Jobs/export`

export const JOBS_QUERY_KEYS = {
  SEARCH_JOBS: 'searchJobs',
  DOWNLOAD_PROGRAMMING_LOGS: 'DOWNLOAD_PROGRAMMING_LOGS',
  DOWNLOAD_JOB_PHOTOS: 'DOWNLOAD_JOB_PHOTOS',
  REPORT_JOBS: 'REPORT_JOBS'
}
